import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { clarity } from 'react-microsoft-clarity';
import App from './App';
import { ampli } from './ampli';
import './config/sentry.init';
import './styles/index';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      // 임시로 비활성화 - 디버깅용
      console.error('QueryCache Error:', error);
      console.error('Query State:', query.state);

      // // 이전에 data fetch에 성공하여 query에 data가 들어있는 경우
      // if (query.state.data !== undefined) {
      //   // 아무런 동작하지 않음 (stale한 data로 렌더링)
      // }

      // // 이전에 data fetch에 성공한 적이 없는 경우 (잘못된 요청이라고 판단)
      // else if (error instanceof AxiosError) {
      //   // 400, 404 에러인 경우 (잘못된 요청)
      //   if (error.response?.status === 400 || error.response?.status === 404) {
      //     const { errorCode } = error.response.data;
      //     switch (errorCode) {
      //       case '0501':
      //         break;
      //       default:
      //         // 홈으로 이동
      //         window.location.href = `${window.origin}/not-found?from=${window.location.href}`;
      //         break;
      //     }
      //   }
      // }
    },
  }),
});

const isProduction = process.env.REACT_APP_CLIENT_ENVIRONMENT === 'production';

const sessionReplayTracking = sessionReplayPlugin({
  sampleRate: isProduction ? 0.1 : 0.01,
  privacyConfig: {
    defaultMaskLevel: 'medium',
    maskSelector: ['.sensitive-text'],
  },
  debugMode: !isProduction,
});

ampli.load({
  environment: isProduction ? 'production' : 'development',
  client: {
    configuration: {
      defaultTracking: {
        pageViews: {
          trackHistoryChanges: 'pathOnly',
        },
      },
    },
  },
});

ampli.client.add(sessionReplayTracking);

clarity.init('t5b94cb8kh');

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
